import { P2 } from "components/typography/P2"
import { Image } from "iconsax-react"

export const ChooseFile: React.FC<{}> = () => {
  return (
    <div className="w-full h-40 border border-dashed border-accentIcon2 rounded-xl flex flex-col justify-center items-center gap-4 p-10 lg:p-8">
      <Image className="text-pryBase rounded-md border-2 border-pryBase min-w-[36px] min-h-[36px] w-9 h-9 p-0" />
      <P2 className="text-accentText font-medium text-center">
        Drop your image here, or{" "}
        <label
          htmlFor="file"
          className="text-pryBase cursor-pointer"
        >
          browse
        </label>{" "}
        <input
          id="file"
          type="file"
          className="hidden"
        />{" "}
        <br />
        <span className="text-accentGrey2">
          JPG,PNG and JPEG files are allowed(max file size of 4MB)
        </span>
      </P2>
    </div>
  )
}
